(function($, duo, undefined) {
  'use strict';

  class Accordion {
    constructor(accordion) {
      this.accordion = accordion;
      this.accordionPanel = document.getElementById(this.accordion.getAttribute('aria-controls')) ? document.getElementById(this.accordion.getAttribute('aria-controls')) : false;

      /* set internal state */
      this.open = this.accordion.getAttribute('aria-expanded') === 'true';

      /* set trigger toggle text is found */
      this.triggerToggleText = this.accordion.querySelector('[data-accordion-toggle-text]') ? [] : false;
      if (this.triggerToggleText) {
        this.triggerToggleText['default'] = this.accordion.querySelector('[data-accordion-toggle-text]').innerHTML;
        this.triggerToggleText.toggleText = this.accordion.querySelector('[data-accordion-toggle-text]').getAttribute('data-accordion-toggle-text');
      }

      /* init when related accordion panel is found */
      if (this.accordionPanel) {
        this.init();
      }

    }

    onTriggerClick() {
      this.togglePanel(!this.open);
    }

    init() {
      /* set start height for animations, if open calc the height */
      let panelHeight = 0;

      if (this.open) {
        panelHeight = this.calcHeight(this.accordionPanel);
      }

      this.setHeight(this.accordionPanel, panelHeight);

      /* add animate class */
      if (!this.accordionPanel.classList.contains('animate')) {
        this.accordionPanel.classList.add('animate');
      }

      /* set a data attribute for checking nested accordions */
      this.accordionPanel.dataset.isAccordionPanel = '';

      /* add click event */
      this.accordion.addEventListener('click', this.onTriggerClick.bind(this));
    }

    togglePanel(open) {
      // if open, return, do nothing
      if (open === this.open) {
        return;
      }

      // update the internal state
      this.open = open;

      if (open) {
        this.openPanel();
      } else {
        this.closePanel();
      }
    }

    // Open panel
    openPanel() {
      /* calc the height */
      const panelHeight = this.calcHeight(this.accordionPanel);

      this.setHeight(this.accordionPanel, panelHeight);

      /* if nested adapt parent accordion height */
      const parent = this.accordionPanel.parentNode.closest('[data-is-accordion-panel]');

      if (parent) {
        this.handleNested(parent, panelHeight, this.open);
      }

      /* update trigger text */
      if (this.triggerToggleText) {
        this.accordion.querySelector('[data-accordion-toggle-text]').innerHTML = this.triggerToggleText.toggleText;
      }

      // update aria attributes
      this.accordion.setAttribute('aria-expanded', true);
      this.accordionPanel.setAttribute('aria-expanded', true);
    }

    // Close panel
    closePanel() {
      this.setHeight(this.accordionPanel, 0);

      /* calc the height for substraction */
      const panelHeight = this.calcHeight(this.accordionPanel);

      /* if nested adapt parent accordion height */
      const parent = this.accordionPanel.parentNode.closest('[data-is-accordion-panel]');

      if (parent) {
        this.handleNested(parent, panelHeight, this.open);
      }

      /* update trigger text */
      if (this.triggerToggleText) {
        this.accordion.querySelector('[data-accordion-toggle-text]').innerHTML = this.triggerToggleText['default'];
      }

      // update aria attributes
      this.accordion.setAttribute('aria-expanded', false);
      this.accordionPanel.setAttribute('aria-expanded', false);
    }

    calcHeight(panel) {
      const childsList = panel.children;
      let totalHeight = 0;

      /* loop through childs and get each child it's height and margins for height calc */
      if (childsList) {
        for(let i = 0; i < childsList.length; i++) {
          const childHeight = childsList[i].clientHeight ? childsList[i].clientHeight : 0;
          const topMargin = window.getComputedStyle(childsList[i]).marginTop ? parseFloat(window.getComputedStyle(childsList[i]).marginTop) : 0;
          const bottomMargin = window.getComputedStyle(childsList[i]).marginBottom ? parseFloat(window.getComputedStyle(childsList[i]).marginBottom) : 0;

          totalHeight += childHeight + topMargin + bottomMargin;
        }
      }

      return totalHeight;
    }

    setHeight(panel, height) {
      panel.style.height = height + 'px';
    }

    handleNested(panel, height, open) {
      const oriHeight = window.getComputedStyle(panel).height ? parseFloat(window.getComputedStyle(panel).height) : 0;

      let extraHeight = height;

      /* if closing the panel, make extra height negative for substraction */
      if (!open) {
        extraHeight = extraHeight * -1;
      }

      const panelHeight = parseFloat(oriHeight) + parseFloat(extraHeight);

      /* apply the height */
      this.setHeight(panel, panelHeight);

      /* keep checking if is nested, to adapt parents as well */
      const parent = panel.parentNode.closest('[data-is-accordion-panel]');

      if (parent) {
        this.handleNested(parent, height, open);
      }
    }
  }

  duo.Accordion = Accordion;

})(jQuery, window.duo = window.duo || {});
